import { CloudFunctionEndpoint } from '../types';

const createCloudFunctionEndpoint = (path: string) =>
  `https://us-central1-${process.env.VUE_APP_FIREBASE_CLOUD_FUNCTIONS_PROJECT_ID}.cloudfunctions.net/${path}`;

export const cloudFunctionEndpoints: {
  [key: string]: CloudFunctionEndpoint;
} = Object.freeze({
  createGroup: {
    url: createCloudFunctionEndpoint('createGroup'),
    queryParams: {
      groupName: 'groupName',
      userIdToken: 'userIdToken'
    }
  },
  createNewGroupLink: {
    url: createCloudFunctionEndpoint('createNewGroupLinkId'),
    queryParams: {
      groupId: 'groupId'
    }
  },
  getGroupNameByLinkId: {
    url: createCloudFunctionEndpoint('getGroupNameByLinkId'),
    queryParams: {
      linkId: 'linkId'
    }
  },
  joinWithGroupLink: {
    url: createCloudFunctionEndpoint('joinWithGroupLink'),
    queryParams: {
      userIdToken: 'userIdToken',
      linkId: 'linkId'
    }
  },
  removeGroupId: {
    url: createCloudFunctionEndpoint('removeGroupId'),
    queryParams: {
      email: 'email',
      name: 'name'
    }
  }
});
